import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { Tooltip } from 'embed/components/Tooltip'
import AdvertiserDisclosureContent from './AdvertiserDisclosureContent'

const styles = require('./styles')

const contentOverlay = <AdvertiserDisclosureContent />

const AdvertiserDisclosure = ({ className }: { className?: string }) => (
  <ThemeConsumer>
    {({ colorPrimary }) => (
      <Tooltip overlay={contentOverlay}>
        <a
          data-test-id="adDisclosure"
          className={classnames(
            styles.adDisclosure,
            className,
            css`
              color: ${colorPrimary};
            `,
          )}
        >
          Advertiser Disclosure
        </a>
      </Tooltip>
    )}
  </ThemeConsumer>
)

export { AdvertiserDisclosureContent }
export default AdvertiserDisclosure
